"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Divider = require("../Divider");

var _Divider2 = _interopRequireDefault(_Divider);

var _Avatar = require("../Avatar");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _IconSvg = require("../IconSvg");

var _IconSvg2 = _interopRequireDefault(_IconSvg);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledFlex = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "SidebarUser__StyledFlex",
  componentId: "pcsufo-0"
})(["align-items:center;width:100%;visibility:", ";"], p => p.collapsed ? "hidden" : "visible");

const SidebarUser = (_ref) => {
  let { role, name, src, collapsed } = _ref,
      props = _objectWithoutProperties(_ref, ["role", "name", "src", "collapsed"]);

  return _react2.default.createElement(
    _Box2.default,
    _extends({}, props, { px: 2 }),
    _react2.default.createElement(_Divider2.default, { bg: "palette.ink.700" }),
    _react2.default.createElement(
      _Flex2.default,
      { mt: 3, mx: 2, alignItems: "center", maxHeight: "34px" },
      _react2.default.createElement(
        _Box2.default,
        { mr: collapsed ? 0 : 3 },
        _react2.default.createElement(_Avatar2.default, { src: src, width: 24, height: 24 })
      ),
      _react2.default.createElement(
        StyledFlex,
        { collapsed: collapsed },
        _react2.default.createElement(
          _Box2.default,
          { style: { overflow: "hidden" } },
          _react2.default.createElement(
            _Text2.default,
            {
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden"
              },
              pb: 1,
              fontSize: 1,
              color: "white"
            },
            name
          ),
          _react2.default.createElement(
            _Box2.default,
            null,
            _react2.default.createElement(
              _Text2.default,
              { fontSize: 0, color: "white", opacity: 0.5 },
              role
            )
          )
        ),
        _react2.default.createElement(
          _Box2.default,
          { marginLeft: "auto", pt: 10, pl: 1 },
          _react2.default.createElement(_IconSvg2.default, { name: "down-caret", color: "white", width: "20" })
        )
      )
    )
  );
};

SidebarUser.defaultProps = {
  name: "User full name",
  role: "User role",
  src: "",
  bg: "palette.ink.900"
};

SidebarUser.propTypes = {
  name: _propTypes2.default.string,
  role: _propTypes2.default.string,
  src: _propTypes2.default.string,
  collapsed: _propTypes2.default.bool
};

exports.default = SidebarUser;